import { useEffect } from "react";
import { logger } from "../../utils/logger";
import { breakCyclesInObjectGraph } from "../scene/sceneDispose";

export function useSceneGraphCycleRepair({ sceneObjects, sceneRef }) {
  // If the scene graph ever becomes cyclic, Three.js internal updates can overflow the stack.
  useEffect(() => {
    try {
      if (!sceneRef.current) return;
      const modelGroup = sceneRef.current.getObjectByName("modelGroup") || sceneRef.current;
      const removed = breakCyclesInObjectGraph(modelGroup);
      if (removed > 0) {
        logger.warn(`[Scene] Removed ${removed} cyclic edge(s) from Three.js graph.`);
        window.dispatchEvent(
          new CustomEvent("critter-toast", {
            detail: { message: "Scene graph inconsistency detected and repaired" },
          })
        );
      }
    } catch (e) {
      logger.warn("[Scene] Failed to sanitize scene graph:", e);
    }
  }, [sceneObjects, sceneRef]);
}
